import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Supplier } from '../../classes/supplier';
import { SupplierService } from '../../services/supplier';
import { AuthService } from '../../services/auth';
import { User } from '../../classes/user';
import { LinkedRequest } from '../../interfaces/referrer';
import { splitEmails } from '../../utils/supplierValidation';

@Component({
    selector: 'app-supplier-detail',
    templateUrl: './supplier-detail.component.html',
    styleUrls: ['./supplier-detail.component.css']
})
export class SupplierDetailComponent implements OnInit {
    user: User = new User();
    supplier: Supplier = new Supplier();
    loadError: string = '';

    constructor(private route: ActivatedRoute,
                private router: Router,
                private authService: AuthService,
                private supplierService: SupplierService) {
    }

    ngOnInit(): void {
        this.authService.isUserSignedIn()
            .subscribe({
                next: () => {
                    this.authService.getUser()
                        .subscribe({
                            next: (user: any) => {
                                this.user = user;
                                if (this.user.FKIDUserRole !== 1) {
                                    this.router.navigate(['/dashboard']);
                                    return;
                                }
                                this.loadSupplier();
                            },
                            error: () => {
                                this.router.navigate(['/login']);
                            }
                        });
                },
                error: () => {
                    this.router.navigate(['/login']);
                }
            });
    }

    private loadSupplier(): void {
        this.route.paramMap.subscribe(params => {
            this.supplierService.getByID(params.get('id'))
                .subscribe({
                    next: (supplier: Supplier) => {
                        this.supplier = supplier;
                        this.loadError = '';
                    },
                    error: (err: HttpErrorResponse) => {
                        this.loadError = err.status === 404
                            ? 'Fornitore non trovato.'
                            : 'Non è stato possibile caricare il fornitore.';
                    }
                });
        });
    }

    get linkedRequests(): LinkedRequest[] {
        return this.supplier.requests || [];
    }

    get emails(): string[] {
        return splitEmails(this.supplier.Email);
    }

    customerLabel(request: LinkedRequest): string {
        const company = (request.customer?.CompanyName || '').trim();
        if (company) {
            return company;
        }
        return `${request.customer?.Name || ''} ${request.customer?.Surname || ''}`.trim();
    }

    goToRequestDetail(idRequest: number | undefined) {
        if (idRequest == null) {
            return;
        }
        this.router.navigate(['/richiesta/' + idRequest]);
    }
}
